(ns frontend.ui.page.lp-report-editor.step-4-pending-approval.event
  (:require
   [re-frame.core :as rf]
   [frontend.controller.websocket.event :as ws]
   [frontend.ui.page.lp-report-editor.event :as editor-event]))


(rf/reg-event-fx
 ::reset
 (fn [{db :db} _]
   {:db (assoc-in db [:lp-report-editor :approve] nil)}))

(rf/reg-event-fx
 ::approve-cycle-ok
 (fn [{db :db} [_ investor-identifier resp]]
   {:db (-> db
            (assoc-in [:lp-report-editor :lp-report :lp-report/step] :lp-report.step/approved))
    :fx [[:dispatch [::editor-event/activate-step :lp-report.step/approved]]]}))

(rf/reg-event-fx
 ::approve-cycle-failed
 (fn [{db :db} [_ err]]
   (js/console.log "Approve failed : " err)))

(rf/reg-event-fx
 ::approve-cycle
 (fn [{db :db} [_ report-id]]
   {::ws/send {:id         :lp-report/approve-cycle
               :body       {:report-id report-id}
               :on-success [::approve-cycle-ok report-id]
               :on-error   [::approve-cycle-failed report-id]}}))
